module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAGJJREFUOBFjYBgFdA2B////3wJicsEtshwLtK0BhMnSjEsT1FCYT2hiONGGMuFyJaXiNDOYhQSXrSVBLcOgcHEw1MWXiXE5zVxMM4OJ8RXDoMogKC4Guoz+hRCKC0Y5pIQAAC1Ns6QGUMAOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_HeightMax_normal.png
// module id = 314
// module chunks = 0